import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { nozzelConstant } from "../constants/constants";


class NozzelStore extends EventEmitter {
    constructor() {
        super();
        this.nozzels = [];
    }

    getAll() {
        return this.nozzels;
    }

    handleAction(action) {
        switch (action.type) {
            case nozzelConstant.NOZZEL_CREATED: {
                const { nozzel } = action;
                this.nozzels.push(nozzel);
                this.emit(nozzelConstant.NOZZEL_CREATED, `Nozzel ${nozzel.nozzelName} created successfully.`);
                this.emit(nozzelConstant.NOZZEL_STORE_CHANGE);
                break;
            }
            case nozzelConstant.NOZZEL_CREATION_FAILED: {
                this.emit(nozzelConstant.NOZZEL_CREATION_FAILED, action.msg);
                break;
            }
            case nozzelConstant.NOZZEL_FETCH_ALL: {
                console.log("inside mpd store fetch all");
                this.nozzels = action.data;
                this.emit(nozzelConstant.NOZZEL_STORE_CHANGE);
                break;
            }
            case nozzelConstant.NOZZEL_FETCH_FAILED: {
                this.emit(nozzelConstant.NOZZEL_FETCH_FAILED, action.msg);
                break;
            }
            default:
                break;
        }
    }
}

const nozzelStore = new NozzelStore();
dispatcher.register(nozzelStore.handleAction.bind(nozzelStore));
//window.nozzelStore = nozzelStore;
//window.dispatcher = dispatcher;
export default nozzelStore;


// WEBPACK FOOTER //
// ./src/jsx/store/nozzel-store.jsx